import { useEffect, useState } from 'react';
import { Outlet, NavLink, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { BrandMark } from './BrandMark';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useAuth } from '../auth/AuthProvider';
import { useRole } from '../hooks/useRole';
import { supabase } from '../lib/supabase';

export function DashboardLayout() {
  const { t } = useTranslation();
  const { signOut } = useAuth();
  const { role, canFinance, isMaster, isTemp } = useRole();
  const [menuOpen, setMenuOpen] = useState(false);

  // visibilidade da nav pelo PAPEL real no restaurante (não pelas caps do Master,
  // que são "tudo verdadeiro"). Master sem restaurante vê só a seção de admin.
  const r = role ?? '';
  const ops = ['owner', 'manager', 'waiter'].includes(r);
  const kitchen = ['owner', 'manager', 'kitchen'].includes(r);
  const queue = ['owner', 'manager', 'hostess', 'waiter'].includes(r);
  const admin = ['owner', 'manager'].includes(r);
  const finance = r === 'owner' || (r === 'manager' && canFinance);

  // garçom do turno: mantém o acesso vivo enquanto o painel está aberto
  useEffect(() => {
    if (!isTemp) return;
    const beat = () => void supabase.rpc('staff_heartbeat');
    beat();
    const id = window.setInterval(beat, 10 * 60 * 1000);
    return () => window.clearInterval(id);
  }, [isTemp]);

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <div className="app-sidebar__top">
          <Link className="brand" to="/app">
            <BrandMark className="brand__mark" />
            <span className="brand__name">La <em>petite</em> <span className="brand__accent">table</span></span>
          </Link>
          <button type="button" className="nav-toggle" aria-label="Menu" aria-expanded={menuOpen} onClick={() => setMenuOpen((o) => !o)}>
            {menuOpen ? '×' : '☰'}
          </button>
        </div>

        <nav className={`dash-nav${menuOpen ? ' is-open' : ''}`} onClick={() => setMenuOpen(false)}>
          <NavLink to="/app" end>{t('dashboard.home')}</NavLink>
          {ops && <NavLink to="/app/sessions">{t('floor.title')}</NavLink>}
          {kitchen && <NavLink to="/app/kitchen">{t('kitchen.title')}</NavLink>}
          {ops && <NavLink to="/app/bar">{t('bar.title')}</NavLink>}
          {queue && <NavLink to="/app/waitlist">{t('hostess.title')}</NavLink>}
          {admin && <NavLink to="/app/menu">{t('menu.title')}</NavLink>}
          {admin && <NavLink to="/app/tables">{t('tables.title')}</NavLink>}
          {admin && <NavLink to="/app/loyalty">{t('loyalty.title')}</NavLink>}
          {admin && <NavLink to="/app/crm">{t('crm.title')}</NavLink>}
          {admin && <NavLink to="/app/consultant">{t('consultant.title')}</NavLink>}
          {admin && <NavLink to="/app/team">{t('team.title')}</NavLink>}
          {finance && <NavLink to="/app/billing">{t('billing.title')}</NavLink>}
          {admin && <NavLink to="/app/public">{t('publicsite.nav')}</NavLink>}
          {admin && <NavLink to="/app/settings">{t('settings.title')}</NavLink>}

          {isMaster && (
            <>
              <span className="dash-nav__sec">{t('master.nav')}</span>
              <NavLink to="/app/master" end>{t('master.nav_panel')}</NavLink>
              <NavLink to="/app/master/restaurantes">{t('master.nav_restaurants')}</NavLink>
              <NavLink to="/app/master/premio">{t('master.nav_award')}</NavLink>
              <NavLink to="/app/master/financeiro">{t('master.nav_finance')}</NavLink>
              <NavLink to="/app/master/leads">{t('master.nav_leads')}</NavLink>
            </>
          )}
        </nav>

        <div className="app-sidebar__foot">
          {isTemp && <span className="tag">⏱ {t('dashboard.shift')}</span>}
          <LanguageSwitcher />
          <button type="button" className="btn btn--ghost btn--sm" onClick={() => void signOut()}>{t('auth.signout')}</button>
        </div>
      </aside>

      <main className="app-main app-main--top">
        <Outlet />
      </main>
    </div>
  );
}
